import SectionsSwitcher from './components/SectionsSwitcher';
import SelectedOptionsButton from './components/SelectedOptionsButton';
import React from 'react';
import style from './RestaurantsControlPanel.module.scss';

const RestaurantsControlPanel: React.FC = () => {
	return (
		<div className={style.container} data-test="RestaurantsControlPanel">
			<SectionsSwitcher />
			<SelectedOptionsButton />
		</div>
	);
};

export default RestaurantsControlPanel;
